export function UpdateTranscriptVisualState(currentTime) {
  const allWords = document.getElementById('hypertranscript').querySelectorAll('[data-m]');
  const player = document.getElementById('audio-player');

  function createWordArray() {
    const wordArr = [];

    allWords.forEach((word, i) => {
      const m = parseInt(word.getAttribute('data-m'));
      let p = word.parentNode;
      while (p !== document) {
        if (
          p.tagName.toLowerCase() === 'p'
                    || p.tagName.toLowerCase() === 'figure'
                    || p.tagName.toLowerCase() === 'ul'
        ) {
          break;
        }
        p = p.parentNode;
      }
      wordArr[i] = { n: allWords[i], m, p };
    });

    return wordArr;
  }

  let index = 0;
  const wordArray = createWordArray();
  let words = wordArray.length - 1;

  // Binary search https://en.wikipedia.org/wiki/Binary_search_algorithm
  while (index <= words) {
    const guessIndex = index + ((words - index) >> 1); // >> 1 has the effect of halving and rounding down
    const difference = wordArray[guessIndex].m / 1000 - currentTime; // wordArr[guessIndex].m represents start time of word

    if (difference < 0) {
      // comes before the element
      index = guessIndex + 1;
    } else if (difference > 0) {
      // comes after the element
      words = guessIndex - 1;
    } else {
      // equals the element
      index = guessIndex;
      break;
    }
  }

  wordArray.forEach((word, i) => {
    const { classList } = word.n;

    if (i < index) {
      classList.add('text-black');
      classList.remove('text-[rgb(102,102,102)]');
      classList.remove('active');
    } else {
      classList.add('text-[rgb(102,102,102)]');
      classList.remove('text-black');
    }
  });

  // set current word and para to active

  if (index > 0) {
    if (player.paused === false) {
      wordArray[index - 1].n.classList.add('active');
    }
  }

  const indices = {
    currentWordIndex: index,
  };

  return indices;
}
